import { CSSProperties, ReactNode } from 'react';
import { classNames } from '../../utils';

interface Props {
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

export default function FieldLabel({ className, style, children }: Props) {
  return (
    <label
      className={classNames(
        'block text-sm font-medium leading-6 text-gray-900',
        className,
      )}
      style={style}
    >
      {children}
    </label>
  );
}
